import { INameId } from '@modeso/types__aumico-lib-core-be';
import { INotesTemplateEntityDTO } from '@modeso/types__aumico-lib-notes-be';
export interface INotesTemplateFormValue
    extends Omit<INotesTemplateEntityDTO, 'notesTypes' | 'legalForm' | 'accountBasis'> {
    legalForm: INameId;
    accountBasis: INameId;
    notesTypes: INameId[];
}
